<template>
    <div class="pageBox">
        <Header ref="Header" current='souye'></Header>
        <div class="pageBox_cen">
            <template v-for="(item, index) in list">
                <component :is="mapComponent[item.name]" :select_data="select_data" :title="title"
                    :tableList="tableList" :list='item' :ref="item.name" @change="getRjProductInfo"
                    @goScroll='goScroll' />
            </template>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"
import mapComponent from "@/components/mapComponent.js";
import { get_rj_product_params } from '@/api/product'
export default {
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            mapComponent,
            list: [{
                name: 'contactBanner',
                value: '产品轮播图',
            }, {
                name: 'parameterTable',
                value: '参数表格',
            }],
            navHidden: false, // 导航栏是否隐藏
            lastScrollTop: 0, // 上一次页面滚动的位置
            currentRoute: '',
            id: null,
            product_id: null,
            title: '',
            tableList: [],
            select_data: {},
        }
    },
    created() {
        let { id, product_id } = this.$route.query
        if (id && product_id) {
            this.id = id
            this.product_id = product_id
            this.getRjProductInfo()
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.currentRoute = this.$route.path; // 初始化时获取当前路由地址
        this.$watch('$route', this.onRouteChange);
        var element;
        if (this.nowVibe == 'pc') {
            element = document.documentElement
        } else {
            element = document.documentElement.scrollTop ? document.documentElement : document.body;
        }
        let scrollTop = element.scrollTop;
        if (scrollTop == 0) {
            if (!this.$refs.Header.navHead) {
                this.$refs.Header.headerHover = false;
            }
            this.$refs.Header.headerTrue = false;
        } else {
            this.$refs.Header.headerTrue = true;
            this.$refs.Header.headerHover = true;
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        onRouteChange(newRoute, oldRoute) {
            this.currentRoute = newRoute.path; // 更新当前路由地址
            this.$refs.productCen[0].querValue = this.$route.query.value;
            // this.goScroll(this.$route.query.value)
        },
        handleScroll() {
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
                .scrollTop || 0;
            if (currentScrollTop > this.lastScrollTop) {
                this.navHidden = true;
            } else {
                this.navHidden = false;
            }
            this.lastScrollTop = currentScrollTop;

            // this.$refs.productCen[0].navHidden = this.navHidden;
            if (currentScrollTop == 0) {
                if (!this.$refs.Header.navHead) {
                    this.$refs.Header.headerHover = false;
                } else {
                    this.$refs.Header.mouseoverLi(3);
                }
                this.$refs.Header.headerTrue = false;
            } else {
                this.$refs.Header.headerTrue = true;
                this.$refs.Header.headerHover = true;
            }
        },
        goScroll(e) {
            this.lastScrollTop = e;
            // document.documentElement.scrollTop = e+10;
            var element;
            if (this.nowVibe == 'pc') {
                element = document.documentElement
            } else {
                element = document.documentElement.scrollTop ? document.documentElement : document.body;
            }
            element.scrollTop = e + 10;
        },

        getRjProductInfo(data = {}) {
            let params = { id: this.id, product_id: this.product_id, ...data }
            get_rj_product_params(params).then(res => {
                this.tableList = res.data.list
                this.title = res.data.title
                this.select_data = res.data.select_data
                this.$nextTick(() => {
                    this.$refs.contactBanner[0].setList(res.data.banner)
                })
            })
        },
    },
}
</script>

<style></style>
<style scoped lang="scss">
.pageBox {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    .pageBox_cen {
        flex: 1;
    }
}
</style>